export function getCollectionList(data) {
	let { getCollectionListRequest, getCollectionListError, getCollectionListResult } = this.props;

	this.doAction(
		this.WEB_REQUEST_URL + 'get_collection_list',
		this.createBundle(
			'get_collection_list',
			{ search: data || '' },
			this.GET,
			getCollectionListRequest,
			getCollectionListResult,
			getCollectionListError
		)
	);
}
